// src/plugins/permissions.js
function normalizeRoles(val) {
  if (!val) return []
  if (Array.isArray(val)) return val
  if (typeof val === 'string') return [val]
  return []
}

export default {
  install(app, { store } = {}) {
    if (!store) throw new Error('[permissions] Debes pasar { store } al plugin')

    const canView = (...expectedRoles) => {
      const roleLoaded = store.state.roleLoaded
      const currentRole = store.state.role

      if (!roleLoaded) return false
      if (!currentRole) return false

      return normalizeRoles(expectedRoles)
        .flat()
        .includes(currentRole)
    }

    // Global para templates / Options API
    app.config.globalProperties.$canView = canView
    app.config.globalProperties.$role = store.state // <- reactivo; puedes leer role/roleLoaded

    // Para Composition API si lo quieres
    app.provide('permissions', { canView, store })

    // Directiva opcional "v-can"
    app.directive('can', {
      mounted(el, binding) {
        const expected = normalizeRoles(binding.value)

        const apply = () => {
          el.style.display = canView(...expected) ? '' : 'none'
        }

        apply()

        el.__can_unsub = store.subscribe((mutation) => {
          if (
            mutation.type === 'setRole' ||
            mutation.type === 'clearRole' ||
            mutation.type === 'setUser' ||
            mutation.type === 'clearUser'
          ) {
            apply()
          }
        })
      },
      beforeUnmount(el) {
        if (typeof el.__can_unsub === 'function') el.__can_unsub()
        delete el.__can_unsub
      }
    })
  }
}
